import React from 'react'
import { ArqContext } from '../arq-context/arq-context'
import { iFacadeApi } from '../../facade'

const errorMsg =
  'The ArchitectureProvider component must be a parent of this component in order to use the architecture API. '

const useArq = (): iFacadeApi => {
  const api: iFacadeApi | null = React.useContext(ArqContext)

  if (api === null) throw new Error(errorMsg)

  return api
}

export { useArq }
